<template>
  <v-card
    class="tooltip-container"
    max-height="400"
    :style="{ transform: translate }"
  >
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    position: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    top: 0,
    left: 0
  }),
  watch: {
    position() {
      this.positionTooltip();
    }
  },
  computed: {
    translate() {
      return `translate(${this.left}px,${this.top}px)`;
    }
  },
  methods: {
    positionTooltip() {
      const padding = 8;
      const { width, height } = this.$el.getBoundingClientRect();
      let [left, top] = this.position;
      left += padding;
      if (left + width > window.innerWidth) {
        left = left - padding * 2 - width;
      }
      if (left < 0) {
        left = 0;
      }
      top += padding;
      if (top + height > window.innerHeight) {
        top = window.innerHeight - height;
      }
      this.top = top;
      this.left = left;
    }
  }
};
</script>

<style scoped>
.tooltip-container {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  overflow-y: auto;
  visibility: visible;
  opacity: 1;
}
</style>
